import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as rmd from 'material-ui';
import _ from 'lodash';
import cx from 'classnames';
import RCore from 'RCore';
import { green700, grey200, red500 } from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import Autorenew from 'material-ui/svg-icons/action/autorenew';
import { Link } from 'react-router';
import ContentAdd from 'material-ui/svg-icons/content/add';
import config from 'cfg';
import SMStream from '../SMStream';
import styled from 'styled-components';

import IconDownload from 'material-ui/svg-icons/file/file-download';
import IconShare from 'material-ui/svg-icons/social/share';

const TEAMS = ['FER', 'MER', 'RBR', 'MCL', 'REN', 'WIL', 'SAU', 'STR', 'FIN'];

class EISMStream extends SMStream {
    renderToolbar() {
        let { type } = this.props;
        switch (type) {
            case 'practice':
                return <h1>Practices</h1>;
            case 'qual':
                return <h1>Qual</h1>;
            case 'race':
                return <h1>Race</h1>;
            default:
                return <h1>F1 Session</h1>;
        }
    }

    renderQual(gpId) {
        console.log(gpId, 'gpIdgpId');
        return Promise.resolve([
            ...['qual-p1', 'qual-p2', 'qual-p3'].map(type => ({
                name: 'F1RaceDetailedResultsSMWidget',
                groupKey: `session-full-${gpId}`,
                groupTitle: `Qualification sessions`,
                props: {
                    'data-gp-id': gpId,
                    'data-type': type
                },
                key: `f1-d-${type}-${gpId}`
            })),
            ...['qual-out-p1', 'qual-out-p2'].map(type => ({
                name: 'F1RaceDetailedResultsSMWidget',
                groupKey: `session-out-${gpId}`,
                groupTitle: `Qualification sessions OUT drivers`,
                props: {
                    'data-gp-id': gpId,
                    'data-type': type
                },
                key: `f1-d-${type}-${gpId}`
            })),
            {
                name: 'F1RaceDetailedResultsSMWidget',
                props: {
                    'data-gp-id': gpId,
                    'data-type': 'qual'
                },
                key: `f1-d-qual-${gpId}`
            },
            ...TEAMS.map(type => ({
                name: 'F1QualTeams',
                groupKey: `qual-team-${gpId}`,
                groupTitle: `Qualification H2H Team`,
                props: {
                    'data-gpx-id': gpId,
                    'data-team': type
                },
                key: `f1-q-teams-${type}-${gpId}`
            }))
        ]);
    }

    renderRace(gpId, gp) {
        const eventRace = gp.events.find(ev => ev.name === 'Race');

        return RCore.promiseProps({
            raceOut: fetch(`${config.apis.ss2}/f1/gpx/${gpId}/events/${eventRace.eventId}/race-out`).then(response =>
                response.json()
            )
        }).then(res =>
            Promise.resolve([
                {
                    name: 'F1RaceDetailedResultsSMWidget',
                    props: {
                        'data-gp-id': gpId,
                        'data-type': 'race'
                    },
                    key: `f1-d-race-${gpId}`
                },
                {
                    name: 'F1RaceDetailedResultsSMWidget',
                    groupTitle: `Race detailed results OUT drivers`,
                    groupKey: `d-retired-${gpId}`,
                    props: {
                        'data-gp-id': gpId,
                        'data-type': 'retired'
                    },
                    key: `f1-d-retired-${gpId}`
                },
                {
                    name: 'F1ClosingGap',
                    props: {
                        'data-gpx-id': gpId
                    },
                    key: `f1-closing-gap-${gpId}`
                },
                {
                    name: 'F1AnimatedPodiumSMWidget',
                    props: {
                        'data-gpx-id': gpId
                    },
                    key: `f1-podium-${gpId}`
                },
                {
                    name: 'F1AnimatedFastestLapSMWidget',
                    props: {
                        'data-gpx-id': gpId
                    },
                    key: `f1-fastest-lap-${gpId}`
                },
                ...res.raceOut.map(d => ({
                    name: 'F1DriverIncidentSMWidget',
                    groupKey: `i-drivers-${gpId}`,
                    groupTitle: `Drivers incident race`,
                    props: {
                        'data-gpx-id': gpId,
                        'data-driver': d.driverShortName,
                        'data-incidentType': 'retired',
                        'data-customHeadline': null
                    },
                    key: `f1-i-driver-${d.driverShortName}-${gpId}`
                })),
                {
                    name: 'F1StandingsAfterRace',
                    groupTitle: `Drivers standings after race`,
                    groupKey: 'standingsAfterRaceDrivers',
                    props: {
                        'data-gpx-id': gpId,
                        'data-type': 'drivers',
                        'data-showTop10': false
                    },
                    key: `f1-standings-after-race-drivers-${gpId}`
                },
                {
                    name: 'F1StandingsAfterRace',
                    groupTitle: `Drivers standings after race`,
                    groupKey: 'standingsAfterRaceDrivers',
                    props: {
                        'data-gpx-id': gpId,
                        'data-type': 'drivers',
                        'data-showTop10': true
                    },
                    key: `f1-standings-after-race-drivers-${gpId}`
                },
                {
                    name: 'F1StandingsAfterRace',
                    groupTitle: `Constructor cup standings after race`,
                    props: {
                        'data-gpx-id': gpId,
                        'data-type': 'teams'
                    },
                    key: `f1-standings-after-race-${gpId}`
                },
                {
                    name: 'F1PointsAfterRace',
                    groupTitle: `Drivers after race`,
                    groupKey: 'afterRaceDrivers',
                    props: {
                        'data-gpx-id': gpId,
                        'data-type': 'drivers',
                        'data-showTop10': false
                    },
                    key: `f1-after-race-drivers-${gpId}`
                },
                {
                    name: 'F1PointsAfterRace',
                    groupTitle: `Drivers after race`,
                    groupKey: 'afterRaceDrivers',
                    props: {
                        'data-gpx-id': gpId,
                        'data-type': 'drivers',
                        'data-showTop10': true
                    },
                    key: `f1-after-race-drivers-${gpId}`
                },
                {
                    name: 'F1PointsAfterRace',
                    groupTitle: `Constructor cup after race`,
                    props: {
                        'data-gpx-id': gpId,
                        'data-type': 'teams'
                    },
                    key: `f1-after-race-${gpId}`
                },
                {
                    name: 'F1AnimatedStartingGridSMWidget',
                    groupTitle: `Animated Starting Grid Widget`,
                    props: {
                        'data-gpx-id': gpId,
                        'data-type': 'teams'
                    },
                    key: `f1-starting-grid-${gpId}`
                }
            ])
        );
    }

    renderPractice(gpId) {
        return Promise.resolve(
            _.flatten(
                ['p1', 'p2', 'p3'].map(type => [
                    // {
                    //     name: 'F1RaceResultsSMWidget',
                    //     groupKey: `session-${type}-${gpId}`,
                    //     groupTitle: `Session ${type}`,

                    //     props: {
                    //         'data-gp-id': gpId,
                    //         'data-type': type
                    //     },
                    //     key: `f1-${type}-${gpId}`
                    // },
                    {
                        name: 'F1RaceDetailedResultsSMWidget',
                        groupKey: `session-full-${type}-${gpId}`,
                        groupTitle: `Session ${type}`,
                        props: {
                            'data-gp-id': gpId,
                            'data-type': type
                        },
                        key: `f1-d-${type}-${gpId}`
                    }
                ])
            )
        );
    }

    loadSMWidgets = params => {
        let { gpId } = params;
        let { type } = this.props;
        return RCore.promiseProps({
            gp: fetch(`${config.apis.ss2}/f1/gpx/${gpId}/info`).then(response => response.json())
        }).then(result => {
            switch (type) {
                case 'practice':
                    return this.renderPractice(gpId);
                case 'qual':
                    return this.renderQual(gpId);
                case 'race':
                    return this.renderRace(gpId, result.gp);
                default:
                    return this.renderPractice(gpId);
            }
        });
    };
}

export default EISMStream;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/streams/f1/F1SessionSMStream.js
 **/